<template>
  <div class="main-login-bg">
    <div class="row" style="text-align:center;">
      <div class="col-sm-12">
        <div @keyup.enter="toLogin" class="hold-transition login-box">
          <div class="login-logo" style="margin-bottom:30px;">
            <img src="/brand-logo.png" style="width:90%;max-width:450px;" />
          </div>
          <!-- /.login-logo -->
          <p>{{ $ml.get('loginPage.welcome') }}</p>
          <div class="login-box-body" style="border:1px #000 solid;">
            <p>{{ $ml.get('loginPage.fullScreenInfo') }}</p>
            <div class="overlay" id="load" style="font-size:50px" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="form-group has-feedback">
              <input type="text" class="form-control" :placeholder="$ml.get('loginPage.emailOrUsername')"
                v-model="user.userName" />
              <span class="fa fa-user form-control-feedback" style="color:#3C8DBC;"></span>
            </div>
            <div class="form-group has-feedback">
              <input type="password" class="form-control" :placeholder="$ml.get('loginPage.password')"
                v-model="user.password" />
              <span class="fa fa-lock form-control-feedback" style="color:#3C8DBC;"></span>
            </div>
            <div class="row">
              <div class="col-xs-8">
                <div class="input-group">
                  <span class="input-group-addon">
                    <img :src="flag" />
                    <i v-show="flag == ''" class="fa fa-globe"></i>
                  </span>
                  <select @change="changeLanguage($event)" class="form-control">
                    <option v-for="lang in $ml.list" :key="lang" :value="lang" :selected="defaultLanguage == lang">
                      {{ lang }}</option>
                  </select>
                </div>
              </div>
              <!-- /.col -->
              <div class="col-xs-4">
                <button :disabled="isLoading" type="button" class="btn btn-primary btn-block"
                  @click.prevent="toLogin()">{{ $ml.get('loginPage.loginButton') }}</button>
              </div>
              <!-- /.col -->
            </div>
          </div>
          <!-- /.login-box-body -->
          <div style="text-align:center; margin-top:20px;">
            <span>&copy; {{ new Date().getFullYear() }}</span>
            <strong>
              <a :href="$store.getters.getCompanyURL" target="_blank">{{ $store.getters.getCompanyName }}</a>
            </strong>
            <br />
            <span>{{ $ml.get('shared.allRightsReserved') }}</span>
            <br />
            <b>{{ $ml.get('shared.version') }}</b>
            {{ version }}
          </div>
          <div class="row" style="margin-top:15px; margin-bottom:20px;text-align: center;">
            <div class="col-sm-12">
              <a :href="$store.getters.getCompanyURL" target="_blank">
                <img src="/company-logo.png" width="200px" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- /.MODAL START-->
    <div class="modal modal-danger fade" id="modal-licence">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">
              <span>{{ $ml.get('shared.licenceErrorTitle') }}</span>
            </h4>
          </div>
          <div class="modal-body">
            <h3>{{ $ml.get('shared.licenceError') }}</h3>
            <hr />
            <h4>{{ $ml.get('shared.softwareKey') }}</h4>
            <span>{{ $ml.get('shared.softwareKeyDescription') }}</span>
            <label class="form-control">{{ this.softwareKey }}</label>
            <hr />
            <h4>{{ $ml.get('shared.enterLicenceKey') }}</h4>
            <span>{{ $ml.get('shared.licenceKeyDescription') }}</span>
            <input type="text" class="form-control" v-model="licenceKey" />
          </div>
          <div class="modal-footer">
            <button class="btn btn-danger text-white" data-dismiss="modal">
              <i class="fa fa-remove"></i>
              <span>{{ $ml.get('general.cancel') }}</span>
            </button>
            <button class="btn btn-success text-white" @click="saveLicenceKey" data-dismiss="modal">
              <i class="fa fa-check"></i>
              <span>{{ $ml.get('shared.saveLicenceKey') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /.MODAL END -->
  </div>
</template>
<script>
import { MLBuilder } from "vue-multilanguage";
export default {
  data() {
    return {
      user: {
        userName: "",
        password: ""
      },
      softwareKey: "",
      licenceKey: "",
      version: this.$store.state.version,
      flag: "",
      defaultLanguage: "",
      isLoading: false,
      errorDescription: "",
      errorStatu: false
    };
  },
  computed: {
    loginAlertMsgs() {
      return new MLBuilder("msg").with("f", this.user.userName);
    },
  },
  methods: {
    changeLanguage(event) {
      this.defaultLanguage = event.target.value;
      localStorage.setItem("lang", this.defaultLanguage);
      if (event.target.value == "English") {
        this.flag = "/src/assets/flags/GB.png";
      } else {
        this.flag = "/src/assets/flags/TR.png";
      }
      this.$ml.change(event.target.value);
    },
    async toLogin() {
      let vm = this;
      if (this.user.userName == null || this.user.userName == "") {
        alertify.warning(vm.$ml.get("alerts.wrongEmailOrUsername"));
        return;
      } else if (this.user.password == null || this.user.password == "") {
        alertify.warning(vm.$ml.get("alerts.wrongPassword"));
        return;
      } else {
        this.isLoading = true;
        var url = await this.$store.getters.getBaseURL;
        let auth =
          "Login?mail=" +
          this.user.userName +
          "&" +
          "password=" +
          this.user.password;
        await this.$axios
          .post(url + "/api/" + auth)
          .then(response => {
            if (response.status == 200) {
              let user = {
                id: response.data.id,
                mail: response.data.mail,
                userName: response.data.userName,
                companyName: response.data.companyName,
                token: response.data.token,
                title: response.data.title,
                profileUrl: response.data.profileUrl,
                defaultVisitorCardGroup: response.data.defaultVisitorCardGroup,
                realtimeMonitorGroup: response.data.realtimeMonitorGroup,
                authType: response.data.authType,
                language: this.defaultLanguage,
                defaultFilters: response.data.filter
              };
              this.$store.commit("setUser", user);
              localStorage.setItem("id", user.id);
              localStorage.setItem("userName", user.userName);
              localStorage.setItem("email", user.mail);
              localStorage.setItem("companyName", user.companyName);
              localStorage.setItem("token", user.token);
              localStorage.setItem("title", user.title);
              localStorage.setItem("profileUrl", user.profileUrl);
              localStorage.setItem("authType", user.authType);
              localStorage.setItem("lang", this.defaultLanguage);
              localStorage.setItem("defaultFilters", JSON.stringify(user.defaultFilters));
              if (user.defaultVisitorCardGroup) {
                localStorage.setItem(
                  "defaultVisitorCardGroup",
                  user.defaultVisitorCardGroup
                );
              } else {
                localStorage.setItem("defaultVisitorCardGroup", 0);
              }
              var currentUrl = window.location.origin;
              window.location.href = currentUrl + "/dashboard";
              //this.$router.push("/redirect");
              //this.isLoading = false;
            } else if (response.status == 210) {
              $("#modal-licence").modal("show");
              alertify.error(vm.$ml.get('shared.licenceError'));
              this.softwareKey = response.data.message;
              this.isLoading = false;
              return;
            } else {
              alertify.warning(response.data.message);
              console.log(response);
              this.isLoading = false;
            }
          })
          .catch(error => {
            console.log(error);
            if (error.response) {
              if (error.response.status == 401) {
                alertify.error(vm.$ml.get("alerts.undefinedUser"));
                this.isLoading = false;
              } else if (error.response.status == 404) {
                alertify.error(vm.$ml.get("alerts.userNotFound"));
                this.isLoading = false;
              } else {
                console.error(error);
                this.isLoading = false;
              }
            }
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(vm.$ml.get("errors.connectionError"));
              this.isLoading = false;
            } else {
              alertify.error(error.response.status + " - " + error.message);
              this.isLoading = false;
            }
          });
      }
    },
    async saveLicenceKey() {
      let vm = this;
      if (this.licenceKey == null || this.licenceKey == "") {
        alertify.warning(vm.$ml.get("shared.wrongLicenceKey"));
        return;
      } else {
        this.isLoading = true;
        var url = await this.$store.getters.getBaseURL;
        let auth =
          "SaveLicence"
        await this.$axios
          .post(url + auth, { licenceKey: this.licenceKey })
          .then(response => {
            if (response.status == 200) {
              alertify.success(vm.$ml.get("shared.saveLicenceKeySuccessfully"));
              this.isLoading = false;
              return;
            } else {
              alertify.warning(response.data.message);
              console.log(response);
              this.isLoading = false;
            }
          })
          .catch(error => {
            console.log(error);
            if (error.response) {
              if (error.response.status == 401) {
                alertify.error(vm.$ml.get("alerts.undefinedUser"));
                this.isLoading = false;
              } else if (error.response.status == 404) {
                alertify.error(vm.$ml.get("alerts.userNotFound"));
                this.isLoading = false;
              } else {
                console.error(error);
                this.isLoading = false;
              }
            }
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(vm.$ml.get("errors.connectionError"));
              this.isLoading = false;
            } else {
              alertify.error(error.response.status + " - " + error.message);
              this.isLoading = false;
            }
          });
      }
    }
  },
  created() {
    //document.body.style.backgroundColor = "#00a0f0";
    let language = localStorage.getItem("lang");
    if (language) {
      if (language != "English" && language != "Türkçe") {
        localStorage.setItem("lang", "Türkçe");
        this.defaultLanguage = "Türkçe";
        this.flag = "/src/assets/flags/TR.png";
      }
      this.defaultLanguage = language;
      if (language == "English") {
        this.flag = "/src/assets/flags/GB.png";
      } else {
        this.flag = "/src/assets/flags/TR.png";
      }
      this.$ml.change(language);
    } else {
      localStorage.setItem("lang", "Türkçe");
      this.defaultLanguage = "Türkçe";
      this.flag = "/src/assets/flags/TR.png";
    }
  }
};
</script>
<style scoped>
.carousel-caption {
  top: 10%;
}

.main-login-bg {
  background: #ffffff;
  height: calc(100vh) + 30px;
  width: 100%;
}

.icon-box {
  position: relative;
  margin-top: 20px;
  padding: 0 0 0 80px;
}

.icon-left {
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  top: 0;
  left: 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/auth/SignIn.vue